import { Link } from 'react-router-dom';
import SEO from '../components/common/SEO';
import './NotFound.css';

const NotFound = () => {
  return (
    <div className="not-found">
      <SEO title="Page Not Found" description="The page you are looking for does not exist." />
      <meta name="robots" content="noindex" />
      <div className="not-found-content">
        <h1>404</h1>
        <h2>Page Not Found</h2>
        <p>The page you&apos;re looking for doesn&apos;t exist.</p>
        <Link to="/" className="btn-primary">
          Go Home
        </Link>
      </div>
    </div>
  );
};

export default NotFound;
